import Typo from './Typo';

export default Typo;
